
//使用mockjs的模板生成随机数据
const data = {
    "code": 200,
    "data": {
        "temp": "25",
        "pm2p5": "9",
        "humidity": "39"
    },
    "message": "success"
}
export default data;

